
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { VMenu } from '../types';

@Component
export default class InputDatePicker extends Vue {
  @Prop({ required: true }) dateValue!: string;

  @Prop({ default() { return () => true; } }) allowedDates!: () => boolean;

  @Prop({ default: false }) range!: boolean;

  @Prop({ default: true }) isFuture!: boolean;

  private showMenu = false;

  private syncedDateValue = '';

  get formattedSelectedDate(): string {
    return moment(this.dateValue).format('LL');
  }

  @Watch('dateValue', { immediate: true })
  private onDateValueChange(value: string): void {
    this.syncedDateValue = value;
  }

  private closePicker() {
    if (!this.$refs.menu) return;
    (this.$refs.menu as VMenu).save(this.syncedDateValue);
    this.$emit('closePicker');
  }

  private async handleApplyDate(): Promise<void> {
    this.$emit('apply', this.syncedDateValue);
    this.closePicker();
  }
}
